import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
    Row, Col, Button, FormGroup, Label, Input, Alert, Modal,
    ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API } from 'aws-amplify';
import '../estilos.css';
import {
    updateRecibaSeriales, updatePProduccion, updateRecuperacion,
    updateRecibaSerialesMP
} from '../../graphql/mutations';
import * as IoIcons from 'react-icons/io';
import Moment, { updateLocale } from 'moment';
import { GetPProduccionID, GetRecibaSerialesID, GetRecuperacion, GetRecuperacionID, GetUsuarios } from '../queries/Queries';
import { cambioUbicacionSeriales } from '../queries/DCUbicaciones';
import { generateClient } from "aws-amplify/api";

const API = generateClient();

const initialfFormState = { formType: 'Producción' }


function Recuperacion() {
    //Declaración de variables            
    const [recuperacion, setRecuperacion] = useState([]);
    const [pRecuperacion, setPRecuperacion] = useState([]);
    const [pInspeccion, setPInspeccion] = useState([]);
    const [recuperacionSF, setRecuperacionSF] = useState([]);
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const ppproduccion = window.$ProduccionRecuperacion ? window.$ProduccionRecuperacion : false;
    const [cargando, setCargando] = useState(false);
    const [nombreUsuario, setNombreUsuario] = useState("");
    const [aVisible, setAVisible] = useState(false);
    const onDismiss = () => setAVisible(false);
    const [modal2, setModal2] = useState(false);
    const [modal1, setModal1] = useState(false);
    const [ultimoNumeroP, setultimoNumeroP] = useState(0);
    const [cnaLiberar, setCNALiberar] = useState(false);
    const [caLiberar, setCALiberar] = useState(false);
    const [paginas, setPaginas] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();
    now2.setMonth(now2.getMonth() - 1);
    const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
    const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));

    const toggle2 = () => setModal2(!modal2);
    const toggle1 = () => setModal1(!modal1);

    // current page
    const [currentPage, setCurrentPage] = useState(1);
    // total records per page to display
    const recordPerPage = 20
        ;

    function handlePageChangeLocacion(recuperacionFromAPI, pageNumber) {
        setAVisible(false);
        setCargando(false);

        setCurrentPage(pageNumber);

        setRecuperacion(recuperacionFromAPI.filter(recuperacion => recuperacion.indexpag === pageNumber));
        //busquedaPlaneacion(planeacionSinFiltro, pageNumber, fechaPBusqueda); 
    }

    function onChanges(lista, i, e) {
        e.persist();
        lista[i][e.target.name] = e.target.value;
        return lista;
    }
    function onChangesPI(e) {
        e.persist()
        setPInspeccion(() => ({
            ...pInspeccion, [e.target.name]: e.target.value
        }));
    }

    function onChangesCantidad(e) {
        e.persist()
        const re = /^[0-9\.]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            if (e.target.name === "CAprobado") {
                const cantidadAprobada = e.target.value != "" ? parseInt(e.target.value) : 0;
                const cantidadNAprobada = e.target.value != "" ? parseInt(pInspeccion.cantidadDisponible) - parseInt(e.target.value) :
                    parseInt(pInspeccion.cantidadDisponible);
                setPInspeccion(() => ({
                    ...pInspeccion, [e.target.name]: cantidadAprobada, ["CNAprobado"]: cantidadNAprobada,
                    ["CLiberar"]: (cnaLiberar ? cantidadNAprobada : 0) + (caLiberar ? cantidadAprobada : 0),
                    ["cantidadNAprobada"]: cantidadNAprobada, ["cantidadAprobada"]: cantidadAprobada
                }));

            } else {
                setPInspeccion(() => ({
                    ...pInspeccion, [e.target.name]: e.target.value
                }));
            }
        }
    }
    //Método useEffect
    useEffect(() => {
        fetchMaterialRecuperacion(rfechaini, rfechafin);
        fetchUsuario();
    }, []);

    //Obtiene el nombre de usuario del usuario logueado
    async function fetchUsuario() {
        //Filtro por planeación activa        
        let filter = {
            usuario: {
                eq: userName
            }
        }
        //Se obtienen los datos de los usuarios
        var apiData = await GetUsuarios(filter);
        const dataFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        setNombreUsuario(dataFromAPI[0].nombreCompleto);
    }
    //Obtiene los datos guardados del material en recuperación
    async function fetchMaterialRecuperacion(fechainicial, fechafinal) {
        //Filtro por planeación activa
        setCargando(true);
        var pag = 1;
        var i = 1;
        var index = 1
        var paginasp = [];
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            },
            {
                fechaEntrada: {
                    ge: fechainicial
                }
            },
            {
                fechaEntrada: {
                    le: fechafinal
                }
            }
            ]
        }

        //Se obtienen los datos de las piezas en recuperación        
        var apiData = await GetRecuperacion(filter);
        //Se ordenan los datos.
        const recuperacionFromAPI = apiData.sort((a, b) =>
            a.fechaEntradaReal < b.fechaEntradaReal ? 1 : a.fechaEntradaReal > b.fechaEntradaReal ? -1 : 0);
        await Promise.all(recuperacionFromAPI.map(async (mRecuperacion) => {
            mRecuperacion.Inspecctor = mRecuperacion.ingresadoPor;
            mRecuperacion.mIRecuperacion = mRecuperacion.mRecuperacion;

            mRecuperacion.cantidadDisponible = mRecuperacion.cantidad - (mRecuperacion.cantidadLiberada ? mRecuperacion.cantidadLiberada : 0);

            mRecuperacion.Inspeccion = mRecuperacion.ultimaInspeccion ? mRecuperacion.ultimaInspeccion + 1 : 1;

            mRecuperacion.CAprobado = mRecuperacion.Revision5CAprobado ? mRecuperacion.Revision5CALiberado === false ? mRecuperacion.Revision5CAprobado : 0 :
                mRecuperacion.Revision4CAprobado ? mRecuperacion.Revision4CALiberado === false ? mRecuperacion.Revision4CAprobado : 0 :
                    mRecuperacion.Revision3CAprobado ? mRecuperacion.Revision3CALiberado === false ? mRecuperacion.Revision3CAprobado : 0 :
                        mRecuperacion.Revision2CAprobado ? mRecuperacion.Revision2CALiberado === false ? mRecuperacion.Revision2CAprobado : 0 :
                            mRecuperacion.Revision1CAprobado ? mRecuperacion.Revision1CALiberada === false ? mRecuperacion.Revision1CAprobado : 0 : 0;


            mRecuperacion.CAprobadot = parseInt(mRecuperacion.CAprobado ? mRecuperacion.CAprobado : 0) + parseInt(mRecuperacion.piezasRecuperadas ? mRecuperacion.piezasRecuperadas : 0);

            mRecuperacion.CNAprobado = parseInt(mRecuperacion.cantidad) - parseInt(mRecuperacion.cantidadLiberada ? mRecuperacion.cantidadLiberada : 0)
                - parseInt(mRecuperacion.CAprobado ? mRecuperacion.CAprobado : 0);
            mRecuperacion.CLiberar = 0;
            mRecuperacion.Inspeccionar = mRecuperacion.Inspeccion === 6 ? true : mRecuperacion.cantidadDisponible <= 0 ? true : false;

            //Paginación
            mRecuperacion.indexpag = pag;
            index++;
            if (index > recordPerPage) {
                paginasp.push({ pagina: pag, paginareal: pag });
                index = 1;
                pag++;
            }
            mRecuperacion.color = "";
            if (i === 2) {
                mRecuperacion.color = "table-active";
                i = 0;
            }
            i++;
            return mRecuperacion;
        }))
        if (recuperacionFromAPI.length) {
            const lengthlocaciones = recuperacionFromAPI.length;
            const prepaginas = parseInt(lengthlocaciones / recordPerPage);
            const paginas = prepaginas * recordPerPage < lengthlocaciones ? prepaginas + 1 : prepaginas;
            if (paginas > paginasp.length)
                paginasp.push({ pagina: paginas })
            setPaginas(paginasp);
            setultimoNumeroP(paginasp[paginasp.length - 1].pagina);
        } else {
            setPaginas([]);
            setultimoNumeroP(0);
        }
        setRecuperacionSF(recuperacionFromAPI);
        handlePageChangeLocacion(recuperacionFromAPI, currentPage);
        setTotalRecords(recuperacionFromAPI.length);

        //setRecuperacion(recuperacionFromAPI);
        setCargando(false);

    }
    //Obtiene los datos guardados del material para hacer la recepción en recuperación
    async function fetchMaterialRecuperacionEntrada() {
        //Filtro por planeación activa
        setCargando(true);
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            },
            {
                fechaEntrada: {
                    attributeExists: false
                }
            }/*,
            {
                piezasInspeccion: {
                    gt: 0
                }
            }*/
            ]
        }

        //Se obtienen los datos de las piezas en recuperación
        var apiData = await GetRecuperacion(filter);
        //Se ordenan los datos de la información obtenida
        const recuperacionFromAPI = apiData.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);
        await Promise.all(recuperacionFromAPI.map(async (recuperacion, i) => {
            recuperacion.ingresadoPor = recuperacion.ingresadoPorUsuario;
            return recuperacion;
        }))
        setPRecuperacion(recuperacionFromAPI);
        setCargando(false);

    }
    async function clicRecepcion() {
        await fetchMaterialRecuperacionEntrada();
        setModal2(!modal2);
    };
    async function clicInspeccion(mRecuperacion) {
        setPInspeccion(mRecuperacion);
        setModal1(!modal1);
        setCNALiberar(false);
        setCALiberar(false);
    };
    async function aceptarAgregar() {
        setAVisible(false);
        setCargando(true);
        setModal2(!modal2);
        try {//Se revisa si faltan datos o si hay concurrencia.
            var faltaIngresado = false;
            var pConcurrencia = false;
            //setMensajeAlert("Filtrando datos");
            const materialSeleccionado = pRecuperacion.filter(material => material.seleccionada === true);
            //setMensajeAlert("Revisando datos faltantes");
            await Promise.all(materialSeleccionado.map(async smaterial => {
                if (!smaterial.ingresadoPor || !smaterial.ingresadoPor === "") {
                    faltaIngresado = true;
                }
                //Se obtienen los datos del material en recuperacion para revisar la concurrencia                
                //Se obtienen los datos de recuperación por id
                const dataFromAPI = await GetRecuperacionID(smaterial.id);
                setMensajeAlert("Ya se obtuvieron los datos  " + JSON.stringify(dataFromAPI));
                if (!dataFromAPI.id) {
                    pConcurrencia = true;
                    //setMensajeAlert("Se revisa concurrencia2");
                } else {
                    if (dataFromAPI.updatedAt !== smaterial.updatedAt) {
                        pConcurrencia = true;
                    }
                    //setMensajeAlert("Se revisa concurrencia1");
                }
            }));
            var mensaje = "";
            if (faltaIngresado === true) {
                mensaje = "No se tiene el dato de la persona que ingresa el material, favor de asegurarse que todos los registros seleccionados tienen dicho dato";
                //setMensajeAlert("No se tiene el dato de la persona que ingresa el material, favor de asegurarse que todos los registros seleccionados tienen dicho dato");
            }

            if (mensaje !== "") {
                setMensajeAlert(mensaje);
                setColor("warning");
                setCargando(false);
                setAVisible(true);
            } else {
                //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se actualiza el número de Inspección o calidad.
                //Además, se guarda la ubicación en Ubicaciones
                if (pConcurrencia === false) {
                    setMensajeAlert("Obteniendo datos");
                    await Promise.all(materialSeleccionado.map(async smaterial => {
                        //Se guardan los datos en RecibaSeriales                                         
                        //Se obtiene el dato actual de reciba Seriales.
                        //setMensajeAlert("Obteniendo datos");                        
                        const recibaFromAPI = await GetRecibaSerialesID(smaterial.recibaSerialID);
                        //setMensajeAlert("Datos obtenidos datos 1");
                        //Datos requeridos para registrar la operación
                        const fechaSalida = Moment(new Date()).format("YYYY-MM-DD");
                        const horaSalida = Moment(new Date()).format("HH:mm");
                        var PiezasUbicacion = parseInt(smaterial.cantidad);
                        if (recibaFromAPI.id) {
                            //Se cambia la ubicación del material de Producción Inspección o Calidad a Recuperacion.
                            const loacionAnterior = smaterial.LocacionDeIngreso ? smaterial.LocacionDeIngreso : "";
                            const ubicacionAnterior = smaterial.UbicacionDeIngreso;
                            const loacionPiezas = "";;
                            const ubicacionPiezas = "Recuperación";
                            const cantidadPiezas = PiezasUbicacion;
                            var cambioUbicacionAux = [];
                            setMensajeAlert("Antes de obtener los datos del cambio de ubicación");
                            cambioUbicacionAux = await cambioUbicacionSeriales(
                                recibaFromAPI,
                                ubicacionAnterior,
                                loacionAnterior,
                                ubicacionPiezas,
                                loacionPiezas,
                                cantidadPiezas);
                            setMensajeAlert("Despues de obtener los datos del cambio de ubicación Ubicación anterior: " + ubicacionAnterior + " Locación anterior: " + loacionAnterior);
                            if (cambioUbicacionAux.mensaje != "") {
                                setMensajeAlert(cambioUbicacionAux.mensaje);
                                setColor(cambioUbicacionAux.color);
                                setCargando(false);
                                setAVisible(true);
                                return;
                            } else {
                                recibaFromAPI.ultimaUbicacion = cambioUbicacionAux.sUltimaU;
                                recibaFromAPI.rubicaciones = cambioUbicacionAux.sUbicaciones;
                                setMensajeAlert("Ubicaciones agrupadas");
                            }
                            if (smaterial.UbicacionDeIngreso === "Cuarentena") {
                                recibaFromAPI.piezasenCuarentena = parseInt(recibaFromAPI.piezasenCuarentena) - parseInt(smaterial.cantidad) > 0 ? parseInt(recibaFromAPI.piezasenCuarentena) - parseInt(smaterial.cantidad) : 0;
                            }
                            delete recibaFromAPI.createdAt;
                            delete recibaFromAPI.updatedAt;
                            delete recibaFromAPI.__typename;
                            recibaFromAPI.Reg_Mod_Usuario = userName;
                            setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial");
                            let upRecibaS = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaFromAPI } });
                            //Se actualizan los datos en recibaSerialesMP
                            const recibaSerialMPID = recibaFromAPI.recibaSerialMPID;
                            if (recibaFromAPI.recibaSerialMPID) {
                                delete recibaFromAPI.recibaSerialMPID;
                                setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaFromAPI));
                                await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibaFromAPI, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });
                            }
                        }

                        //Se indica la fecha y hora de recepción del material y el usuario que lo recibió                       
                        smaterial.fechaEntrada = fechaSalida;
                        smaterial.horaEntrada = horaSalida;
                        smaterial.Reg_Mod_Usuario = userName;
                        smaterial.fechaEntradaReal = new Date();
                        delete smaterial.createdAt;
                        delete smaterial.updatedAt;
                        delete smaterial.__typename;
                        delete smaterial.seleccionada;
                        setMensajeAlert("Operación errónea; Problemas al guardar los datos del material en recuperación");
                        await API.graphql({ query: updateRecuperacion, variables: { input: smaterial } });

                        //setMensajeAlert("Operación exitosa: Ubicaciones:" + JSON.stringify(auxUltimaUbicacion));

                    }));

                    setMensajeAlert("Operación exitosa"); //, piezas totales: " + piezasTotales + ", piezas en pintado: " + pInspeccion.piezasenPintado
                    setColor("primary");
                    setCargando(false);
                    setAVisible(true);
                    fetchMaterialRecuperacion(rfechaini, rfechafin);
                } else { //Si  hay concurrencia se tienen que actualizar los datos
                    window.scrollTo(0, 0);
                    setMensajeAlert("No fue posible realizar la operación: existe concurrencia, favor de recargar los datos y " +
                        " volver a intentarlo");
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    fetchMaterialRecuperacion(rfechaini, rfechafin);
                }
            }
        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    };
    async function aceptarInspeccion() {
        setAVisible(false);
        setCargando(true);
        setModal1(!modal1);
        setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
        try {//Se revisa si faltan datos o si hay concurrencia.            
            var pConcurrencia = false;
            var mensaje = "";
            const sumatotalal = parseInt(pInspeccion.CLiberar ? pInspeccion.CLiberar : 0) +
                parseInt(pInspeccion.piezasRecuperadas ? pInspeccion.piezasRecuperadas : 0) +
                parseInt(pInspeccion.piezasNRecuperadas ? pInspeccion.piezasNRecuperadas : 0)
            if (pInspeccion.Inspeccion === 5 && sumatotalal != pInspeccion.cantidad) {//&& sumatotalal != pInspeccion.cantidad
                mensaje = "Última inspección, en la última inspección se debe liberar todo el material. Por favor marque para liberar todo el material."; // " Suma total: " +  sumatotalal 
                /*+ sumatotalal + " CAliberar: " + parseInt(pInspeccion.cantidadAprobada? pInspeccion.cantidadAprobada:0) + " CNAliberar: " + parseInt(pInspeccion.cantidadNAprobada?pInspeccion.cantidadNAprobada:0) + 
                " CAliberada: " + parseInt(pInspeccion.piezasRecuperadas?pInspeccion.piezasRecuperadas:0) + " CNAliberada: " + parseInt(pInspeccion.piezasNRecuperadas?pInspeccion.piezasNRecuperadas:0) ;*/
                //setMensajeAlert("No se tiene el dato de la persona que ingresa el material, favor de asegurarse que todos los registros seleccionados tienen dicho dato");
            }
            if (pInspeccion.Inspecctor === "" || pInspeccion.mIRecuperacion === "" || pInspeccion.CAprobado === "") {
                mensaje = "Faltan datos, los campos marcados con asterísco son obligatorios";
                //setMensajeAlert("No se tiene el dato de la persona que ingresa el material, favor de asegurarse que todos los registros seleccionados tienen dicho dato");
            }
            if (pInspeccion.CNAprobado < 0 || pInspeccion.CAprobado < 0) {
                mensaje = "La suma de las cantidades no corresponden a la cantidad en recuperación, favor de verificarlas";
            }

            if (mensaje !== "") {
                setMensajeAlert(mensaje);
                setColor("warning");
                setCargando(false);
                setAVisible(true);
            } else {
                //Se obtienen los datos del material en recuperacion para revisar la concurrencia            
                const dataFromAPI = await GetRecuperacionID(pInspeccion.id);
                //setMensajeAlert("Ya se obtuvieron los datos  " + JSON.stringify(dataFromAPI));
                if (!dataFromAPI.id) {
                    pConcurrencia = true;
                    //setMensajeAlert("Se revisa concurrencia2");
                } else {
                    if (dataFromAPI.updatedAt !== pInspeccion.updatedAt) {
                        pConcurrencia = true;
                    }
                    //setMensajeAlert("Se revisa concurrencia1");
                }
                //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se actualiza el número de Inspección o calidad.
                //Además, se guarda la ubicación en Ubicaciones
                if (pConcurrencia === false) {
                    //Si el material inspeccionado se tiene que liberar a ambarques, se hace el cambio de ubicación y se actualizan datos en RecibaSeriales
                    if (pInspeccion.CLiberar > 0) {
                        //setMensajeAlert("Obteniendo datos");                     
                        //Se cambia la ubicación del material de Producción Recuperación a Calidad.

                        //Datos requeridos para registrar la operación                                             
                        var auxUltimaUbicacion = [];
                        //Se guardan los datos en RecibaSeriales                                        
                        //Se obtiene el dato actual de reciba Seriales.                    
                        const recibaFromAPI = await GetRecibaSerialesID(pInspeccion.recibaSerialID);
                        //setMensajeAlert("Datos obtenidos datos 1");
                        if (recibaFromAPI.id) {
                            //***** */

                            //Registro que corresponde a Producción Calidad
                            var calidad = false;
                            if (pInspeccion.cantidadAprobada > 0 && caLiberar === true && pInspeccion.UbicacionDeIngreso !== "Cuarentena") {
                                const loacionPiezas = "Calidad";
                                const ubicacionPiezas = "Producción";
                                const loacionAnterior = "";
                                const ubicacionAnterior = "Recuperación";
                                const cantidadPiezas = parseInt(pInspeccion.cantidadAprobada);
                                auxUltimaUbicacion = await cambioUbicacionSeriales(recibaFromAPI, ubicacionAnterior, loacionAnterior, ubicacionPiezas, loacionPiezas, cantidadPiezas);

                                setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion));
                                if (auxUltimaUbicacion.mensaje != "") {
                                    setMensajeAlert(auxUltimaUbicacion.mensaje);
                                    setColor(auxUltimaUbicacion.color);
                                    setCargando(false);
                                    setAVisible(true);
                                    return;
                                } else {
                                    recibaFromAPI.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                                    recibaFromAPI.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                                    setMensajeAlert("Ubicaciones agrupadas (1)" + JSON.stringify(auxUltimaUbicacion));
                                }
                                calidad = true;
                            }
                            //Registro que corresponde a Cuarentena
                            if ((pInspeccion.cantidadNAprobada > 0 && cnaLiberar === true) ||
                                (pInspeccion.cantidadAprobada > 0 && caLiberar === true &&
                                    pInspeccion.UbicacionDeIngreso === "Cuarentena")) {
                                const loacionPiezas = "";
                                const ubicacionPiezas = "Cuarentena";
                                const loacionAnterior = "";
                                const ubicacionAnterior = "Recuperación";
                                const cantidadPiezas = pInspeccion.cantidadNAprobada;
                                auxUltimaUbicacion = await cambioUbicacionSeriales(recibaFromAPI, ubicacionAnterior, loacionAnterior, ubicacionPiezas, loacionPiezas, cantidadPiezas, calidad);

                                setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion));
                                if (auxUltimaUbicacion.mensaje != "") {
                                    setMensajeAlert(auxUltimaUbicacion.mensaje);
                                    setColor(auxUltimaUbicacion.color);
                                    setCargando(false);
                                    setAVisible(true);
                                    return;
                                } else {
                                    recibaFromAPI.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                                    recibaFromAPI.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                                    setMensajeAlert("Ubicaciones agrupadas (1)" + JSON.stringify(auxUltimaUbicacion));
                                }
                            }


                            delete recibaFromAPI.createdAt;
                            delete recibaFromAPI.updatedAt;
                            delete recibaFromAPI.__typename;
                            //Si el material viene de cuarentena, 
                            if (pInspeccion.UbicacionDeIngreso === "Cuarentena") {
                                //Se indica que el material regresa a cuarenta
                                recibaFromAPI.piezasenCuarentena = !recibaFromAPI.piezasenCuarentena ? parseInt(pInspeccion.CLiberar) : parseInt(recibaFromAPI.piezasenCuarentena) + parseInt(pInspeccion.CLiberar);
                                recibaFromAPI.PiezasCtnaRecuperacion = recibaFromAPI.PiezasCtnaRecuperacion - parseInt(pInspeccion.CLiberar) > 0 ? recibaFromAPI.PiezasCtnaRecuperacion - parseInt(pInspeccion.CLiberar) : 0;
                                //Si se libera el material aprobado, se suma al indicador  piezasCtnaRecuperadas                                                     
                                if (pInspeccion.cantidadAprobada > 0 && caLiberar === true) {
                                    recibaFromAPI.piezasCtnaRecuperadas = !recibaFromAPI.piezasCtnaRecuperadas ? parseInt(pInspeccion.cantidadAprobada) : parseInt(recibaFromAPI.piezasCtnaRecuperadas) + parseInt(pInspeccion.cantidadAprobada);
                                }
                                //Si las piezas no aprobadas se están liberando, se marcan para embarcar y se suma la cantidad a los indicadores,
                                //piezasNRecuperadas, piezasCtnaNRecuperadas y piezasenCuarentena
                                if (pInspeccion.cantidadNAprobada > 0 && cnaLiberar === true) {
                                    recibaFromAPI.piezasCtnaNRecuperadas = !recibaFromAPI.piezasCtnaNRecuperadas ? parseInt(pInspeccion.cantidadNAprobada) : parseInt(recibaFromAPI.piezasCtnaNRecuperadas) + parseInt(pInspeccion.cantidadNAprobada);
                                    recibaFromAPI.piezasCtnaNAEmbarcar = !recibaFromAPI.piezasCtnaNAEmbarcar ? parseInt(pInspeccion.cantidadNAprobada) : parseInt(recibaFromAPI.piezasCtnaNAEmbarcar) + parseInt(pInspeccion.cantidadNAprobada);
                                }

                            } else {//Si el material viene de producción
                                // se suma a las piezas a embarcar.                                
                                recibaFromAPI.piezasAEmbarcar = !recibaFromAPI.piezasAEmbarcar ? parseInt(pInspeccion.CLiberar) : parseInt(recibaFromAPI.piezasAEmbarcar) + parseInt(pInspeccion.CLiberar);
                                //Si se libera el material aprobado, se suma a las piezas en Calidad, Pintadas y Recuperadas.
                                if (pInspeccion.cantidadAprobada > 0 && caLiberar === true) {
                                    recibaFromAPI.piezasCalidad = !recibaFromAPI.piezasCalidad ? parseInt(pInspeccion.CLiberar) : parseInt(recibaFromAPI.piezasCalidad) + parseInt(pInspeccion.CLiberar);
                                    recibaFromAPI.piezasPintadas = !recibaFromAPI.piezasPintadas ? parseInt(pInspeccion.cantidadAprobada) : parseInt(recibaFromAPI.piezasPintadas) + parseInt(pInspeccion.cantidadAprobada);
                                    recibaFromAPI.piezasRecuperadas = !recibaFromAPI.piezasRecuperadas ? parseInt(pInspeccion.cantidadAprobada) : parseInt(recibaFromAPI.piezasRecuperadas) + parseInt(pInspeccion.cantidadAprobada);
                                }
                                //Si las piezas no aprobadas se están liberando, se suma a las piezas no recuperadas y a las piezas en cuarentena
                                if (pInspeccion.cantidadNAprobada > 0 && cnaLiberar === true) {
                                    recibaFromAPI.piezasNRecuperadas = !recibaFromAPI.piezasNRecuperadas ? parseInt(pInspeccion.cantidadNAprobada) : parseInt(recibaFromAPI.piezasNRecuperadas) + parseInt(pInspeccion.cantidadNAprobada);
                                    recibaFromAPI.piezasenCuarentena = !recibaFromAPI.piezasenCuarentena ? parseInt(pInspeccion.cantidadNAprobada) : parseInt(recibaFromAPI.piezasenCuarentena) + parseInt(pInspeccion.cantidadNAprobada);
                                    recibaFromAPI.piezasCtnaPintadas = !recibaFromAPI.piezasCtnaPintadas ? parseInt(pInspeccion.cantidadNAprobada) : parseInt(recibaFromAPI.piezasCtnaPintadas) + parseInt(pInspeccion.cantidadNAprobada);
                                }
                            }
                            recibaFromAPI.Reg_Mod_Usuario = userName;
                            setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial");
                            let upRecibaS = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaFromAPI } });
                            //Se actualizan los datos en recibaSerialesMP
                            const recibaSerialMPID = recibaFromAPI.recibaSerialMPID;
                            if (recibaFromAPI.recibaSerialMPID) {
                                delete recibaFromAPI.recibaSerialMPID;
                                setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaFromAPI));
                                await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibaFromAPI, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });
                            }
                        };
                        //Se guardan los datos en PProduccion                                       
                        //Se obtiene el dato actual de Plan de producción.
                        //setMensajeAlert("Obteniendo datos");         
                        if (pInspeccion.pProduccionID) {
                            const pProduccionFromAPI = await GetPProduccionID(pInspeccion.pProduccionID);
                            //setMensajeAlert("Datos obtenidos datos 1");
                            if (pProduccionFromAPI.id) {
                                delete pProduccionFromAPI.createdAt;
                                delete pProduccionFromAPI.updatedAt;
                                delete pProduccionFromAPI.__typename;
                                pProduccionFromAPI.piezasCalidad = !pProduccionFromAPI.piezasCalidad ? parseInt(pInspeccion.CLiberar) : parseInt(pProduccionFromAPI.piezasCalidad) + parseInt(pInspeccion.CLiberar);
                                if (pInspeccion.cantidadAprobada > 0 && caLiberar === true) {
                                    pProduccionFromAPI.piezasPintadas = !pProduccionFromAPI.piezasPintadas ? parseInt(pInspeccion.cantidadAprobada) : parseInt(pProduccionFromAPI.piezasPintadas) + parseInt(pInspeccion.cantidadAprobada);
                                    pProduccionFromAPI.piezasRecuperadas = !pProduccionFromAPI.piezasRecuperadas ? parseInt(pInspeccion.cantidadAprobada) : parseInt(pProduccionFromAPI.piezasRecuperadas) + parseInt(pInspeccion.cantidadAprobada);
                                }
                                if (pInspeccion.cantidadNAprobada > 0 && cnaLiberar === true) {
                                    pProduccionFromAPI.piezasNRecuperadas = !pProduccionFromAPI.piezasNRecuperadas ? parseInt(pInspeccion.cantidadNAprobada) : parseInt(pProduccionFromAPI.piezasNRecuperadas) + parseInt(pInspeccion.cantidadNAprobada);
                                }
                                pProduccionFromAPI.Reg_Mod_Usuario = userName;
                                setMensajeAlert("Operación errónea; Problemas al guardar los datos del plan de producción");
                                await API.graphql({ query: updatePProduccion, variables: { input: pProduccionFromAPI } });
                            };
                        }
                    }
                    //Se registra la inspección y se agrega la fecha de salida del material en caso de que corresponda.    
                    pInspeccion.ultimaInspeccion = pInspeccion.Inspeccion;
                    pInspeccion.cantidadLiberada = !pInspeccion.cantidadLiberada ? parseInt(pInspeccion.CLiberar) : parseInt(pInspeccion.cantidadLiberada) + parseInt(pInspeccion.CLiberar);
                    if (pInspeccion.cantidadAprobada > 0 && caLiberar === true) {
                        pInspeccion.piezasRecuperadas = !pInspeccion.piezasRecuperadas ? parseInt(pInspeccion.cantidadAprobada) : parseInt(pInspeccion.piezasRecuperadas) + parseInt(pInspeccion.cantidadAprobada);
                    }
                    if (pInspeccion.cantidadNAprobada > 0 && cnaLiberar === true) {
                        pInspeccion.piezasNRecuperadas = !pInspeccion.piezasNRecuperadas ? parseInt(pInspeccion.cantidadNAprobada) : parseInt(pInspeccion.piezasNRecuperadas) + parseInt(pInspeccion.cantidadNAprobada);
                    }
                    if (pInspeccion.Inspeccion === 1) {
                        pInspeccion.Revision1Inspector = pInspeccion.Inspecctor;
                        pInspeccion.Revision1Comentarios = pInspeccion.Comentarios;
                        pInspeccion.Revision1CAprobado = pInspeccion.CAprobado;
                        pInspeccion.Revision1CALiberada = caLiberar;
                        pInspeccion.Revision1CNAprobado = pInspeccion.CNAprobado;
                        pInspeccion.Revision1CNALiberada = cnaLiberar;
                        pInspeccion.Revision1MRecuperacion = pInspeccion.mIRecuperacion;
                    }
                    if (pInspeccion.Inspeccion === 2) {
                        pInspeccion.Revision2Inspector = pInspeccion.Inspecctor;
                        pInspeccion.Revision2Comentarios = pInspeccion.Comentarios;
                        pInspeccion.Revision2CAprobado = pInspeccion.CAprobado;
                        pInspeccion.Revision2CALiberado = caLiberar;
                        pInspeccion.Revision2CNAprobado = pInspeccion.CNAprobado;
                        pInspeccion.Revision2CNALiberado = cnaLiberar;
                        pInspeccion.Revision2MRecuperacion = pInspeccion.mIRecuperacion;
                    }
                    if (pInspeccion.Inspeccion === 3) {
                        pInspeccion.Revision3Inspector = pInspeccion.Inspecctor;
                        pInspeccion.Revision3Comentarios = pInspeccion.Comentarios;
                        pInspeccion.Revision3CAprobado = pInspeccion.CAprobado;
                        pInspeccion.Revision3CALiberado = caLiberar;
                        pInspeccion.Revision3CNAprobado = pInspeccion.CNAprobado;
                        pInspeccion.Revision3CNALiberado = cnaLiberar;
                        pInspeccion.Revision3MRecuperacion = pInspeccion.mIRecuperacion;
                    }
                    if (pInspeccion.Inspeccion === 4) {
                        pInspeccion.Revision4Inspector = pInspeccion.Inspecctor;
                        pInspeccion.Revision4Comentarios = pInspeccion.Comentarios;
                        pInspeccion.Revision4CAprobado = pInspeccion.CAprobado;
                        pInspeccion.Revision4CALiberado = caLiberar;
                        pInspeccion.Revision4CNAprobado = pInspeccion.CNAprobado;
                        pInspeccion.Revision4CNALiberado = cnaLiberar;
                        pInspeccion.Revision4MRecuperacion = pInspeccion.mIRecuperacion;
                    }
                    if (pInspeccion.Inspeccion === 5) {
                        pInspeccion.Revision5Inspector = pInspeccion.Inspecctor;
                        pInspeccion.Revision5Comentarios = pInspeccion.Comentarios;
                        pInspeccion.Revision5CAprobado = pInspeccion.CAprobado;
                        pInspeccion.Revision5CALiberado = caLiberar;
                        pInspeccion.Revision5CNAprobado = pInspeccion.CNAprobado;
                        pInspeccion.Revision5CNALiberado = cnaLiberar;
                        pInspeccion.Revision5MRecuperacion = pInspeccion.mIRecuperacion;
                    }
                    if (pInspeccion.cantidad === pInspeccion.cantidadLiberada) {
                        pInspeccion.fechaSalida = Moment(new Date()).format("YYYY-MM-DD");
                        pInspeccion.horaSalida = Moment(new Date()).format("HH:mm");
                    }
                    pInspeccion.Reg_Mod_Usuario = userName;
                    //pInspeccion.fechaEntradaReal = new Date();
                    delete pInspeccion.createdAt;
                    delete pInspeccion.updatedAt;
                    delete pInspeccion.__typename;
                    delete pInspeccion.Inspeccionar;
                    delete pInspeccion.Inspecctor;
                    delete pInspeccion.mIRecuperacion;
                    delete pInspeccion.CNAprobado;
                    delete pInspeccion.CAprobado;
                    delete pInspeccion.CAprobadot;
                    delete pInspeccion.CLiberar;
                    delete pInspeccion.Inspeccion;
                    delete pInspeccion.cantidadNAprobada;
                    delete pInspeccion.cantidadAprobada;
                    delete pInspeccion.Comentarios;
                    delete pInspeccion.cantidadDisponible;
                    delete pInspeccion.indexpag;
                    delete pInspeccion.color;
                    setMensajeAlert("Operación errónea; Problemas al guardar los datos del material en recuperación");
                    await API.graphql({ query: updateRecuperacion, variables: { input: pInspeccion } });

                    setMensajeAlert("Operación exitosa");
                    //setMensajeAlert("Operación exitosa"); //, piezas totales: " + piezasTotales + ", piezas en pintado: " + pInspeccion.piezasenPintado
                    setColor("primary");
                    setCargando(false);
                    setAVisible(true);
                    fetchMaterialRecuperacion(rfechaini, rfechafin);
                } else { //Si  hay concurrencia se tienen que actualizar los datos
                    window.scrollTo(0, 0);
                    setMensajeAlert("No fue posible realizar la operación: existe concurrencia, favor de recargar los datos y " +
                        " volver a intentarlo");
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    fetchMaterialRecuperacion(rfechaini, rfechafin);
                }
            }
        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    };
    function onChangesCheckAgregar(lista, i) {
        if (!lista[i].seleccionada || lista[i].seleccionada === false) {
            lista[i].seleccionada = true
        } else {
            lista[i].seleccionada = false
        }
        //setHabilitado(sinSeleccion);
        return lista;
    }
    function onChangesCheckLiberar(e) {
        //e.persist();
        var cantidadAprobada = 0;
        var cantidadNAprobada = 0;
        var CALiberar = caLiberar;
        var CNALiberar = cnaLiberar;

        if (e.target.name === "CALiberado") {
            setCALiberar(e.target.checked);
            CALiberar = e.target.checked;
            if (e.target.checked === true) {
                cantidadAprobada = pInspeccion.CAprobado ? pInspeccion.CAprobado : 0;
            }
            setPInspeccion(() => ({
                ...pInspeccion, ["CLiberar"]: parseInt(CALiberar ? cantidadAprobada : 0) + parseInt(CNALiberar ? pInspeccion.cantidadNAprobada ? pInspeccion.cantidadNAprobada : 0 : 0),
                ["cantidadAprobada"]: cantidadAprobada
            }));
            //["CLiberar"]: (cnaLiberar? cantidadNAprobada:0) +  (caLiberar? cantidadAprobada :0)
        }
        if (e.target.name === "CNALiberado") {
            setCNALiberar(e.target.checked);
            CNALiberar = e.target.checked;
            if (e.target.checked === true) {
                cantidadNAprobada = pInspeccion.CNAprobado ? pInspeccion.CNAprobado : 0;
            }
            setPInspeccion(() => ({
                ...pInspeccion, ["CLiberar"]: parseInt(CALiberar ? pInspeccion.cantidadAprobada ? pInspeccion.cantidadAprobada : 0 : 0) + parseInt(CNALiberar ? cantidadNAprobada : 0),
                ["cantidadNAprobada"]: cantidadNAprobada
            }));
        }

    };

    //Revisa cambios en la fecha de búsqueda
    function onChangesRFechaini(e) {
        e.persist()
        var fechaini = rfechaini;
        var fechafin = rfechafin;
        if (e.target.name === "rfechaini") {
            fechaini = e.target.value;
        } else {
            fechafin = e.target.value;
        }
        setRfechafin(fechafin);
        setRfechaini(fechaini);
        fetchMaterialRecuperacion(fechaini, fechafin);

    }

    return (
        <>
            {ppproduccion === true && (
                <>
                    <Fragment>

                        <Row>
                            <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                <h5 className=" floatleft ml-3">Material en recuperación</h5>
                            </div>
                            <div className=" form-group row col-lg-3 col-md-6 col-sm-12 col-xs-12   margintop20px   ml-1 ">
                                <InputGroup className="floatleft">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>Del:</InputGroupText>
                                    </InputGroupAddon>
                                    <Input name="rfechaini" type="date" value={Moment(rfechaini).format("YYYY-MM-DD")} onChange={onChangesRFechaini} />
                                </InputGroup>
                            </div>
                            <div className=" form-group row col-lg-3 col-md-6 col-sm-12 col-xs-12   margintop20px  ml-1 ">
                                <InputGroup className="floatrightleft ml-1">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>Al:</InputGroupText>
                                    </InputGroupAddon>
                                    <Input name="rfechafin" type="date" value={Moment(rfechafin).format("YYYY-MM-DD")} onChange={onChangesRFechaini} />
                                </InputGroup>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                <button className="cbutton btn-dark floatright  mr-3 " title="Recargar página" onClick={() => { fetchMaterialRecuperacion(rfechaini, rfechafin); }}><IoIcons.IoMdRefresh /> Recargar </button>
                                <button className="cbutton btn-success floatright mr-3" title="Recepción de material" onClick={() => { clicRecepcion(); }}><IoIcons.IoIosAddCircle /> Recepción </button>
                            </div>
                            <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 margintop20px">
                            </div>
                        </Row>
                        <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                                    {mensajeAlert}
                                </Alert>
                            </div>
                            {cargando === true && (
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            )}
                        </Row>
                        {recuperacion.length > 0 && (
                            <>
                                <div >
                                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                        <Table className="mb-2 scroll " >
                                            <Thead class="thead-secondary">
                                                <Tr>
                                                    <Th>No.</Th>
                                                    <Th className="minwidth100px">Fecha de entrada</Th>
                                                    <Th className="minwidth100px">Número de parte</Th>
                                                    <Th className="minwidth100px">Descripción</Th>
                                                    <Th>Cantidad</Th>
                                                    <Th>Cliente</Th>
                                                    {<Th>Serial BTI</Th>}
                                                    <Th className="minwidth100p ">Defecto</Th>
                                                    <Th className="minwidth60p ">Método de recuperación Sugerido</Th>
                                                    <Th className="minwidth60p ">Ingresado por</Th>
                                                    <Th className="minwidth60p ">Área</Th>
                                                    <Th className="minwidth60p ">Inspecciones</Th>
                                                    <Th className="minwidth60p ">Material aprobado</Th>
                                                    <Th className="minwidth60p ">Material liberado</Th>
                                                    <Th className="minwidth60p ">Fecha de salida</Th>
                                                    <Th className="minwidth80px ">Acciones</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {recuperacion.map((mrecuperacion, i) => (
                                                    <Tr class={mrecuperacion.color} >
                                                        <Td>{i + 1}</Td>
                                                        <Td>{mrecuperacion.fechaEntrada} </Td>
                                                        <Td>{mrecuperacion.numerodeParte}</Td>
                                                        <Td >{mrecuperacion.descripcion}</Td>
                                                        <Td className={mrecuperacion.descripcion ? "" : "margintopmobil20px"}>{mrecuperacion.cantidad}</Td>
                                                        <Td>{mrecuperacion.cliente}</Td>
                                                        {<Td >{mrecuperacion.serialRecibaBTI}</Td>}
                                                        <Td >{mrecuperacion.defecto}</Td>
                                                        <Td>{mrecuperacion.mRecuperacion === "Otro" ? mrecuperacion.otroMRecuperacion : mrecuperacion.mRecuperacion}</Td>
                                                        <Td className="margintopmobil40px ">{mrecuperacion.ingresadoPor}</Td>
                                                        <Td>{mrecuperacion.ingresadoPorArea}</Td>
                                                        <Td>{mrecuperacion.ultimaInspeccion}</Td>
                                                        <Td>{mrecuperacion.CAprobadot > 0 ? mrecuperacion.CAprobadot : ""}</Td>
                                                        <Td className="margintopmobil20px ">{mrecuperacion.cantidadLiberada > 0 ? mrecuperacion.cantidadLiberada : ""}</Td>
                                                        <Td className="margintopmobil20px ">{mrecuperacion.fechaSalida}</Td>
                                                        <Td ><button className="cbutton btn-primary  mt-1 ml-1 " title="Registrar inspección" onClick={() => { clicInspeccion(mrecuperacion); }} disabled={mrecuperacion.Inspeccionar} ><IoIcons.IoMdSearch /></button>
                                                        </Td>
                                                    </Tr>

                                                ))}
                                            </Tbody>
                                        </Table>
                                    </div>
                                    <div className="mt-3 mb-3">
                                        Página {currentPage}, mostrando del {(recordPerPage * currentPage - recordPerPage) + 1}  al {totalRecords < recordPerPage * currentPage ? totalRecords : recordPerPage * currentPage} de {totalRecords} registros
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12  ">
                                        <div class="floatcenter">
                                            <ul class="pagination">
                                                <li class={currentPage === 1 ? "page-item disabled" : "page-item"}>
                                                    <a class="page-link" href="#" aria-label="Go to first page" onClick={() => handlePageChangeLocacion(recuperacionSF, 1)}>«</a>
                                                </li>
                                                <li class={currentPage === 1 ? "page-item disabled" : "page-item"}>
                                                    <a class="page-link" href="#" aria-label="Go to previous page" onClick={() => handlePageChangeLocacion(recuperacionSF, currentPage - 1)}>⟨</a>
                                                </li>
                                                {paginas.map(pagina => (
                                                    <li class={currentPage === pagina.pagina ? "page-item active" : "page-item "}>
                                                        <a class="page-link " onClick={() => handlePageChangeLocacion(recuperacionSF, pagina.pagina)}>{pagina.pagina}</a>
                                                    </li>
                                                ))}
                                                <li class={currentPage === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                                                    <a class="page-link" href="#" aria-label="Go to next page" onClick={() => handlePageChangeLocacion(recuperacionSF, currentPage + 1)}>⟩</a>
                                                </li>
                                                <li class={currentPage === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                                                    <a class="page-link" href="#" aria-label="Go to last page" onClick={() => handlePageChangeLocacion(recuperacionSF, ultimoNumeroP)}>»</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        <Modal isOpen={modal2} size="lg" toggle={toggle2} >
                            <ModalHeader toggle={toggle2} >Recepción de material</ModalHeader>
                            <ModalBody>
                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                    <Table className=" mb-2 scroll " >
                                        <Thead class="thead-secondary">
                                            <Tr>
                                                <Th className="minwidth60px ">Agregar</Th>
                                                <Th className="minwidth60px ">Área</Th>
                                                <Th className="minwidth100px">Cliente</Th>
                                                <Th >Número de parte</Th>
                                                <Th >Descripción</Th>
                                                {/*<Th>Serial</Th>*/}
                                                <Th className="minwidth60px ">Cantidad</Th>
                                                <Th className="minwidth60px ">Defecto</Th>
                                                <Th className="minwidth100px ">Ingresado por</Th>
                                                <Th className="minwidth60px ">Método de recuperación sugerido</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {pRecuperacion.map((mrecuperacion, i) => (
                                                <Tr >
                                                    <Td><input type="checkbox" name="enRecuperacion" checked={mrecuperacion.seleccionada} class="form-check-input ml-3" onChange={(e) => setPRecuperacion(onChangesCheckAgregar([...pRecuperacion], i))} /></Td>
                                                    <Td className="margintopmobil20px">{mrecuperacion.ingresadoPorArea}</Td>
                                                    <Td>{mrecuperacion.cliente}</Td>
                                                    <Td>{mrecuperacion.numerodeParte}</Td>
                                                    <Td >{mrecuperacion.descripcion}</Td>
                                                    {/*<Td className={mrecuperacion.descripcion ? "" : "margintopmobil20px"}>{mrecuperacion.serial}</Td>*/}
                                                    <Td className={mrecuperacion.descripcion ? "" : "margintopmobil20px"}>{mrecuperacion.cantidad > 0 ? mrecuperacion.cantidad : ""}</Td>
                                                    <Td>{mrecuperacion.defecto ? mrecuperacion.defecto : mrecuperacion.otroDefecto}</Td>
                                                    <Td> <Input type="textarea" name="ingresadoPor" rows="3" value={mrecuperacion.ingresadoPor} onChange={(e) => setPRecuperacion(onChanges([...pRecuperacion], i, e))} /></Td>
                                                    <Td className="marginbottommobil40px">{mrecuperacion.mRecuperacion ? mrecuperacion.mRecuperacion : mrecuperacion.otroMRecuperacion}</Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                    </Table>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                {/*pInspeccion.piezasEnRecuperando*/}
                                <Button color="primary" onClick={aceptarAgregar}>Aceptar</Button>{' '}
                                <Button color="danger" onClick={toggle2}>Cancelar</Button>
                            </ModalFooter>
                            {/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(pRecuperacion)}</div>*/}
                        </Modal>
                        <Modal isOpen={modal1} size="lg" toggle={toggle1} >
                            <ModalHeader toggle={toggle1} >Inspección de material - {pInspeccion.Inspeccion}</ModalHeader>
                            <ModalBody>
                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                    <Table className=" mb-2 scroll " >
                                        <Thead class="thead-secondary">
                                            <Tr>
                                                <Th className="minwidth60px ">Fecha de entrada</Th>
                                                <Th className="minwidth60px ">Área</Th>
                                                <Th className="minwidth100px">Cliente</Th>
                                                <Th >Número de parte</Th>
                                                <Th >Descripción</Th>
                                                {/*<Th>Serial</Th>*/}
                                                <Th className="minwidth60px ">Cantidad</Th>
                                                <Th className="minwidth60px ">Defecto</Th>
                                                <Th className="minwidth100px ">Ingresado por</Th>
                                                <Th className="minwidth60px ">Método de recuperación sugerido</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            <Tr >
                                                <Td>{pInspeccion.fechaEntrada}</Td>
                                                <Td >{pInspeccion.ingresadoPorArea}</Td>
                                                <Td>{pInspeccion.cliente}</Td>
                                                <Td>{pInspeccion.numerodeParte}</Td>
                                                <Td >{pInspeccion.descripcion}</Td>
                                                {/*<Td className={pInspeccion.descripcion ? "" : "margintopmobil20px"}>{pInspeccion.serial}</Td>*/}
                                                <Td className={pInspeccion.descripcion ? "" : "margintopmobil20px"}>{pInspeccion.cantidadDisponible > 0 ? pInspeccion.cantidadDisponible : ""}</Td>
                                                <Td>{pInspeccion.defecto ? pInspeccion.defecto : pInspeccion.otroDefecto}</Td>
                                                <Td>{pInspeccion.ingresadoPor}</Td>
                                                <Td className="marginbottommobil40px">{pInspeccion.mRecuperacion ? pInspeccion.mRecuperacion : pInspeccion.otroMRecuperacion}</Td>
                                            </Tr>
                                        </Tbody>
                                    </Table>
                                </div>
                                <Row >
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px">
                                        <FormGroup>
                                            <Label className="floatleft ">Método de recuperación* {/*pInspeccion.piezasEnRecuperando*/}</Label>
                                            <Input name="mIRecuperacion" value={pInspeccion.mIRecuperacion} onChange={e => onChangesPI(e)} />
                                        </FormGroup>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop20px">
                                        <Label className="floatleft" >Inspector* </Label>
                                        <Input name="Inspecctor" value={pInspeccion.Inspecctor} onChange={e => onChangesPI(e)} />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px">
                                        <FormGroup>
                                            <Label className="floatleft ">Piezas aprobadas* <input type="checkbox" name="CALiberado" onChange={(e) => onChangesCheckLiberar(e)} />Liberar a {pInspeccion.UbicacionDeIngreso}</Label>
                                            <Input name="CAprobado" value={pInspeccion.CAprobado} onChange={e => onChangesCantidad(e)} />
                                        </FormGroup>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px">
                                        <FormGroup>
                                            <Label className="floatleft ">Piezas no aprobadas* <input type="checkbox" name="CNALiberado" onChange={(e) => onChangesCheckLiberar(e)} />Liberar</Label>
                                            <Input name="CNAprobado" value={pInspeccion.CNAprobado} onChange={e => onChangesCantidad(e)} disabled="true" />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <FormGroup>
                                            <Label className="floatleft ">Comentarios:</Label>
                                            <Input type="textarea" rows="2" name="Comentarios" onChange={e => onChangesPI(e)} />
                                        </FormGroup>
                                    </div>
                                </Row>
                            </ModalBody>
                            <ModalFooter>
                                {/*pInspeccion.piezasEnRecuperando*/}
                                <Button color="primary" onClick={aceptarInspeccion}>Aceptar</Button>{' '}
                                <Button color="danger" onClick={toggle1}>Cancelar</Button>
                            </ModalFooter>
                            {/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(pInspeccion)}</div>*/}
                        </Modal>
                        {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(pInspeccion)}</div>*/}
                        {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(Moment(now).format("YYY-MM-DD"))}</div>*/}
                    </Fragment>

                </>
            )}
        </>
    )
};



export default Recuperacion;
